import { Box } from '@quintoandar-tokko/jopijs';
import styles from './Radio.module.scss';

function Radio(props) {
  return <Box as="input" type="radio" className={styles.radio} {...props} />;
}

export default Radio;
